import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { Toaster } from 'react-hot-toast';
import classnames from 'classnames';
import find from 'lodash/find';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import {updateUser, getUser} from 'store/actions/user';
import RenderRoutes from 'components/Routes/RenderRoutes';
import Sidebar from 'components/Sidebar/Sidebar';
import Topbar from 'containers/Topbar';
import ErrorDialog from 'containers/Dialogs/ErrorDialog';
import Legal from './Legal/Legal';
import {Footer, FooterProvider} from './Footer/Footer';
import CustomModuleContainer from './CustomModuleContainer';
import {createReplacePatch} from 'helpers/patchHelper';
import {cookiesTypes, getCookies} from 'helpers/cookieHelper';
import {isLoggedOut} from 'helpers/accountHelper';
import tryMe from 'helpers/tryMe';
import palette from 'theme/palette';
import {setupSystemThemeListener, applyTheme} from 'helpers/themeHelper';
import {layouts, entityNames} from 'config/constants';
import routes from 'config/routes';
import {fetchTimeZones} from "../store/actions/account";

class App extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: {
        sidebarMobile: false,
      },
      isCollapsed: null,
      isHovered: false,
      isContentFixed: false,
      footerRef: null,
    };
  }

  componentDidMount() {
    var self = this;
    this._removeSystemThemeListener = setupSystemThemeListener(function() {
      var themeMode = self.props.app.themeMode;
      if (themeMode === 'system') {
        applyTheme('system');
      }
    });
  }

  componentWillUnmount() {
    if (this._removeSystemThemeListener) {
      this._removeSystemThemeListener();
    }
  }

  UNSAFE_componentWillMount() {
    if (getCookies(cookiesTypes.USER_COOKIE)) {
      this.props.getUser();
    }
    this.props.fetchTimeZones();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {currentUser} = nextProps;

    if (currentUser && currentUser.etagChanged) {
      this.props.getUser();
    }

    if (!isLoggedOut(currentUser)) {
      if (currentUser.dashboardSettings) {
        let collapsed =
          currentUser.dashboardSettings.navigationPaneCollapsed;
        this.setState({isCollapsed: collapsed});
      }
    }

    // check app path change
    const oldPath = this.props.app.path;
    const newPath = nextProps.app.path;

    if (oldPath !== newPath) {
      const newRoute = find(routes, (item) => item.path === newPath);

      this.setState({
        isHovered: false,
        isContentFixed: newRoute.isContentFixed,
        noPaddingContainer: newRoute.noPaddingContainer,
        noScrollContainer: newRoute.noScrollContainer,
      });
    }
  }

  render() {
    const {app, currentAccount, accountsList, currentUser} = this.props;
    const {notFoundError} = tryMe(this.props.location.state);
    const {footerRef, noPaddingContainer, noScrollContainer} = this.state;

    return (
      <div
        // tabIndex={0} // ToDo find out why it is necessary
        className={classnames(`app`, {
          'sidebar-collapsed': this.state.isCollapsed,
          'sidebar-opened': this.state.isOpen.sidebarMobile,
          'layout-404': notFoundError,
          'layout-public': isLoggedOut(currentUser) && app.layout === layouts.DASHBOARD,
          [`layout-${app.layout}`]: !notFoundError,
        })}
      >
        {app.layout === layouts.DASHBOARD && !notFoundError && !isLoggedOut(currentUser) && (
          <Sidebar
            isCollapsed={this.state.isCollapsed}
            isHovered={this.state.isHovered}
            onClose={this.closeSidebarMobile}
            onToggle={this.toggleSidebarDesktop}
            onMouseEnter={
              this.state.isCollapsed ? this.handleMouseEnter : undefined
            }
            onMouseLeave={
              this.state.isCollapsed ? this.handleMouseLeave : undefined
            }
          />
        )}
        <section className="views">
          <div className="view" onClick={this.handleMouseLeave}>
            {this.state.isOpen.sidebarMobile && (
              <div
                className="sidebar-overlay"
                onClick={this.closeSidebarMobile}
              />
            )}
            <div className="pages" id="pages">
              <div className="page" id="page">
                <FooterProvider value={{ ref: footerRef }}>
                  <div
                    className={classnames('container', {
                      'no-padding-container': noPaddingContainer,
                      'no-scroll-container': noScrollContainer,
                      'with-empty-footer':
                        !footerRef || footerRef.childNodes.length < 1,
                    })}
                  >
                    <ErrorDialog />
                    <RenderRoutes isContentFixed={this.state.isContentFixed} />
                    <CustomModuleContainer />
                    {app.layout === layouts.SIGN && !notFoundError && (
                      <Legal />
                    )}
                    <Footer
                      onSetRef={(footerRef) => this.setState({ footerRef })}
                      onChildrenChange={() => this.forceUpdate()}
                    />
                  </div>
                </FooterProvider>
              </div>
            </div>
            {app.layout === layouts.DASHBOARD && !notFoundError && (
              <Topbar
                handleSidebarToggle={this.toggleSidebarMobile}
                isOpenSidebarMobile={this.state.isOpen.sidebarMobile}
                accountsList={accountsList}
                currentAccountUuid={currentAccount && currentAccount.uuid}
              />
            )}
          </div>
        </section>
        {ReactDOM.createPortal(
          <Toaster
            position="bottom-center"
            containerStyle={{ zIndex: 1500 }}
            toastOptions={{
              duration: 5000,
              style: {
                background: palette.sidebarBgHover,
                color: palette.white,
                borderRadius: '8px',
                padding: '12px 16px',
                boxShadow: '0 4px 6px -1px rgba(30, 36, 51, 0.1)',
                maxWidth: '500px',
              },
              success: {
                style: { background: palette.sidebarBgHover, color: palette.white },
                iconTheme: { primary: palette.white, secondary: palette.sidebarBgHover },
              },
              error: {
                style: { background: palette.error, color: palette.white },
                iconTheme: { primary: palette.white, secondary: palette.error },
              },
            }}
          />,
          document.body
        )}
      </div>
    );
  }

  toggleSidebarDesktop = () => {
    let collapse = !this.state.isCollapsed;
    let { isHovered } = this.state;

    if (collapse) {
      isHovered = false;
    }

    this.setState({ isCollapsed: collapse, isHovered });

    let data = {};
    data.patches = [
      createReplacePatch(
        `/dashboardSettings/navigationPaneCollapsed`,
        collapse,
      ),
    ];

    this.props.updateUser(data, entityNames.DASHBOARD_SETTINGS);
  };

  toggleSidebarMobile = () => {
    this.setState({
      isOpen: { sidebarMobile: !this.state.isOpen.sidebarMobile },
    });
  };

  closeSidebarMobile = () => {
    this.setState({ isOpen: { sidebarMobile: false } });
  };

  handleMouseEnter = (e) => {
    if (e) {
      e.preventDefault();
    }

    this.setState({ isHovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false });
  };

}

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  app: state.app,
  accountsList: state.accounts.accountsList,
  currentAccount: state.accounts.currentAccount,
});

export default withRouter(
  connect(mapStateToProps, {
    updateUser,
    getUser,
    fetchTimeZones,
  })(App),
);
